var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-cabinet-estates-list-table"},[_c('div',{staticClass:"page-cabinet-estates-list-table__body"},_vm._l((_vm.items),function(item,i){return _c('div',{key:i,staticClass:"page-cabinet-estates-list-table__body-row"},[_c('page-cabinet-estates-list-table-item',{attrs:{"item":item,"fields":_vm.fields}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }